import React from 'react';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import { Button } from '../../atoms/Button';

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex justify-center items-center gap-2 mt-8">
      {/* First Page */}
      <Button
        variant="secondary"
        size="small"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        className="flex items-center gap-1"
        title="İlk sayfa"
      >
        <ChevronsLeft className="w-4 h-4" />
      </Button>

      {/* Page Numbers */}
      <div className="flex items-center gap-1">
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let pageNum: number;

          if (totalPages <= 5) {
            // 5 veya daha az sayfa varsa hepsini göster
            pageNum = i + 1;
          } else if (currentPage <= 3) {
            // İlk sayfalardaysak ilk 5'i göster
            pageNum = i + 1;
          } else if (currentPage >= totalPages - 2) {
            // Son sayfalardaysak son 5'i göster
            pageNum = totalPages - 4 + i;
          } else {
            // Ortadaysak mevcut sayfanın etrafındaki 5'i göster
            pageNum = currentPage - 2 + i;
          }

          const isActive = pageNum === currentPage;

          return (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`
                min-w-[2.5rem] h-10 px-3 rounded-lg text-sm font-medium
                transition-all duration-200
                ${isActive
                  ? 'bg-accent text-white shadow-md scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200 hover:border-gray-300'
                }
              `}
              title={`Sayfa ${pageNum}`}
            >
              {pageNum}
            </button>
          );
        })}
      </div>

      {/* Last Page */}
      <Button
        variant="secondary"
        size="small"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        className="flex items-center gap-1"
        title="Son sayfa"
      >
        <ChevronsRight className="w-4 h-4" />
      </Button>
    </div>
  );
};
